import { render, staticRenderFns } from "./AdditionIcon.vue?vue&type=template&id=0178855a&"
import script from "./AdditionIcon.vue?vue&type=script&lang=ts&"
export * from "./AdditionIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports